import React from 'react';
import mask from '../assets/images/Mask group (2).png';
import people from '../assets/images/people.png';
import squares from '../assets/images/squares.png';
import goal from '../assets/images/goal.png';
import layer from '../assets/images/Layer_1 (1).png';
import layer1 from '../assets/images/Layer_1.png';
import logic from '../assets/images/logical-thinking.png';
import welfare from '../assets/images/welfare.png';
import company from '../assets/images/company-vision.png';
import back_img from '../assets/images/career_img.png';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import funnel from '../assets/images/funnel.svg';

function Career() {
  const kpiData = [
    { heading: 'Growth Opportunities', content: goal },
    { heading: 'Challenging and Impactful Work', content: layer1 },
    { heading: 'Competitive Compensation and Benefits', content: welfare },
    { heading: 'Employee Recognition and Rewards', content: layer },
    { heading: 'Company Culture and Values', content: company },
    { heading: 'Learning and Development Opportunities', content: logic },
  ];

  const Openings = [
    { heading: 'Relationship Manager', location: 'Mumbai || Pune || Delhi' },
    { heading: 'Renewal Manager', location: 'HO' },
    { heading: 'Operation Executive', location: 'Mumbai || Panvel || Meerut' },
  ];
  return (
    <div className="w-full ">
      <section className=" relative h-[140px] md:h-[320px] lg:h-[430px] xl:h-[570px] flex justify-center items-center">
        <img
          src={back_img}
          alt=""
          className="absolute top-0 w-full z-0 h-full "
        />
        <div className="relative sm:ml-10 sm:mt-20 md:ml-52 md:mt-60">
          <a href="https://forms.gle/UtqXR2Lc2jdh8ayS7">
            <button className="xs:h-7 xs:px-3 md:h-12 bg-sky-900 md:px-8 py-1 rounded-xl text-white xs:text-xs md:text-sm my-8 gradient pointer">
              Apply Now
            </button>
          </a>
        </div>
      </section>

      <section className="flex flex-col md:flex-row items-center xl:mt-20  px-8 xs:py-10 md:py-28 md:px-16">
        <div className="w-full  md:w-1/2 px-2 pt-8 md:pt-0">
          <p className="text-team border-l-8 border-[#003478] pl-6 ">
            Join Our Talented Team
          </p>
          <p className="team-p">
            Look no further if you seek dynamic, enriching, and challenging
            career opportunities at Efficient, where we prioritize building
            long-term relationships with our employees and transforming the
            insurance industry into a fun and simplified experience. We extend
            our invitation to individuals from diverse backgrounds to join the
            fastest-growing InsurTech in India and shape their careers.
            <br />
          </p>
        </div>
        <div
          style={{ width: '562px' }}
          className=" md:w-1/2  h-[340px] mx-12 md:mx-0"
        >
          <img
            src={mask}
            alt=""
            // className="absolute "
          />
        </div>
      </section>
      <section
        style={{ background: 'rgba(0, 52, 120, 0.9)' }}
        className="p-12 md:py-8 md:px-12 lg:px-32 xl:px-60 relative flex flex-row flex-wrap gap-8 justify-center "
      >
        <div className="join">Why Join Efficient?</div>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            width: '971px',
            justifyContent: 'center',
          }}
        >
          {kpiData.map((item, index) => (
            <div
              key={index.toString()}
              className="grid gap-3 text-center place-content-center  rounded-xl  p-4 w-48 h-32 z-10 xl:m-8"
            >
              <img
                src={item.content}
                alt=""
                width="60px"
                className="justify-self-center"
              ></img>
              <p className="font-normal text-base text-white justify-self-center">
                {item.heading}
              </p>
            </div>
          ))}
        </div>
        {/* <img src={squares} alt="" className="absolute bottom-0 w-full" /> */}
      </section>
      <section className=" pr-8 flex "></section>

      <section className="xs:py-10 md:py-24 grid justify-items-center">
        <div className="w-10/12 md:w-8/12">
          <p className="text-blue-900 font-bold text-3xl">
            Our Current Openings
          </p>
          <div className="flex gap-2 justify-items-center mr-5 place-content-end justify-self-end">
            <img src={funnel} alt="Filter" />
            <p style={{ color: '#8796A8' }} className="text-sm">
              Filter
            </p>
          </div>
          <div className="mt-4">
            {Openings.map((el, i) => {
              return (
                <div
                  key={i}
                  className="shadow-lg rounded-2xl mb-10 flex justify-around md:justify-between md:px-10 items-center"
                >
                  <div className="text-center grid gap-3">
                    <div>
                      <p className="font-semibold text-base">{el.heading}</p>
                    </div>
                    <div className="flex gap-2 justify-items-center">
                      <LocationOnIcon sx={{ color: '#e1e1d0' }} />
                      <p className="font-semibold text-sm">{el.location}</p>
                    </div>
                  </div>
                  <div>
                    <a href="https://forms.gle/UtqXR2Lc2jdh8ayS7">
                      <button className="h-12 bg-gradient-to-r from-sky-400 to-sky-700 px-8 py-1 rounded-xl text-white text-sm my-5 gradient">
                        Apply Now
                      </button>
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Career;
